import React from "react";
import Container from "../../../layout/Container";
import {buildStyles} from "../../../buildStyles";
import {useTheme} from "../../../../theme/ThemeProvider";
import ListComponent from "../../../layout/list/ListComponent";
import ListItemContainer from "../../../layout/list/ListItemContainer";
import Text from "../../../display/Text";
import {relativeDatesMap} from "../../../../../configuration/constants";
import {useFeatureFlags} from "../../../../../utilities/featureUtil";

const useStyles = (theme) =>
  buildStyles({
    container: {
      maxHeight: "100%",
      overflowY: "auto",
      borderRight: `1px solid ${theme.colors.border}`,
      paddingRight: theme.spacing(3),
    },
    mobileContainer: {
      maxWidth: "266px",
      overflowX: "auto",
      scrollbarWidth: "thin",
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${theme.colors.border}`,
    },
  });

export default function RelativeDateSidebar({onDateClick}) {
  const {theme, isMobile} = useTheme();
  const classes = useStyles(theme);
  const flag = useFeatureFlags();
  const itemStyles = isMobile ? {whiteSpace: "nowrap"} : {minWidth: "100px"};

  if (!flag.relativeDateFilters) return null;

  return (
    <Container
      className={isMobile ? classes.mobileContainer : classes.container}
    >
      <ListComponent
        gap={theme.spacing(1)}
        orientation={isMobile ? "horizontal" : "vertical"}
      >
        {Object.entries(relativeDatesMap).map(([key, value]) => (
          <Container sx={itemStyles} key={key}>
            <ListItemContainer key={key} onClick={() => onDateClick(value)}>
              <Text variant={"textSM"}>{key}</Text>
            </ListItemContainer>
          </Container>
        ))}
      </ListComponent>
    </Container>
  );
}
